/**
 * Route for `igaming-mass-payout-processing`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingMassPayoutProcessingPage } from "../features/igaming-mass-payout-processing/IgamingMassPayoutProcessingPage";

export const igamingMassPayoutProcessingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-mass-payout-processing",
	component: IgamingMassPayoutProcessingPage,
});

export default igamingMassPayoutProcessingRoute;
